import { CalendarAgenda } from './CalendarAgenda';

export const Content = () => {
  return <CalendarAgenda />;
};
